import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import uniqueId from 'lodash/uniqueId';
import { PapiUser } from '@wix/da-papi-types';
import { AppState } from '../../../types/store';
import {
  getProfileOwner,
  getProfileOwnerUser,
  isCurrentUserProfileOwner,
  isViewingAsVisitor,
} from '../../selectors/users';
import { actions as modalActions } from '@wix/da-shared-react/pkg/Modals';
import { getIsLoggedIn } from '@wix/da-shared-react/pkg/publicSession/selectors';
import { restrictLoggedOut } from '@wix/da-shared-react/pkg/redux/loggedout/actionCreators';
import { startNewChatWithParticipant } from '@wix/da-shared-react/pkg/ChatV2/redux/actions';
import {
  fetchProfileOwnerGiveState,
  fetchProfileOwnerGiveStateSuccess,
} from '../../actions/profileOwner';
import { getPageRoutes } from '../../selectors/pageLayout';
import { biClickProfileNavBar } from '../../actions/bi';
import { SubNavBarProps } from './SubNavBar';

type StateProps = Pick<
  SubNavBarProps,
  | 'isOwner'
  | 'isViewingAsVisitor'
  | 'isLoggedIn'
  | 'giveState'
  | 'profileOwnerUser'
  | 'routes'
>;
type DispatchProps = Pick<
  SubNavBarProps,
  | 'pushBadgeModal'
  | 'pushPointsModal'
  | 'initGiveState'
  | 'onLlamaBadgeSent'
  | 'onCakeBadgeSent'
  | 'onStartChat'
  | 'restrictLoggedOut'
  | 'biClickProfileNavBar'
>;
type OwnProps = Omit<SubNavBarProps, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> =
  state => ({
    isOwner: isCurrentUserProfileOwner(state),
    giveState: getProfileOwner(state).giveState,
    profileOwnerUser: getProfileOwnerUser(state),
    isLoggedIn: getIsLoggedIn(state),
    routes: getPageRoutes(state),
    isViewingAsVisitor: isViewingAsVisitor(state),
  });

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> =
  dispatch => ({
    pushBadgeModal: (username: string, onBadgeSent?: () => void) =>
      dispatch(modalActions.pushBadgeModal(username, onBadgeSent)),
    pushPointsModal: (userId, title) =>
      dispatch(modalActions.pushPointsModal(userId, title)),
    initGiveState: () => dispatch(fetchProfileOwnerGiveState()),
    onLlamaBadgeSent: () =>
      dispatch(fetchProfileOwnerGiveStateSuccess({ canBeGivenLlama: false })),
    onCakeBadgeSent: () =>
      dispatch(fetchProfileOwnerGiveStateSuccess({ canBeGivenCake: false })),
    onStartChat: (user: PapiUser) =>
      dispatch(
        startNewChatWithParticipant(uniqueId('new-chat-request'), {
          id: user.useridUuid,
          name: user.username,
        })
      ),
    restrictLoggedOut: payload => dispatch(restrictLoggedOut(payload)),
    biClickProfileNavBar: linkName => dispatch(biClickProfileNavBar(linkName)),
  });

export default connect(mapStateToProps, mapDispatchToProps);
